import clsx from 'clsx';

export interface BulkAction {
  label: string;
  icon?: string;
  variant?: 'default' | 'danger';
  onClick: () => void;
}

interface BulkActionBarProps {
  selectionCount: number;
  actions: BulkAction[];
  onClear: () => void;
}

export default function BulkActionBar({ selectionCount, actions, onClear }: BulkActionBarProps) {
  if (selectionCount === 0) return null;

  return (
    <div className="sticky bottom-4 z-30 mx-auto max-w-3xl">
      <div className="bg-gray-900 text-white rounded-xl shadow-2xl px-6 py-3 flex items-center gap-4">
        <span className="text-sm font-medium whitespace-nowrap">
          {selectionCount} item{selectionCount !== 1 ? 's' : ''} selected
        </span>
        <div className="h-5 w-px bg-gray-600" />
        <div className="flex items-center gap-2 flex-1 overflow-x-auto">
          {actions.map((action) => (
            <button
              key={action.label}
              onClick={action.onClick}
              className={clsx(
                'px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors',
                action.variant === 'danger'
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'bg-gray-700 hover:bg-gray-600 text-gray-100'
              )}
            >
              {action.icon && <span className="mr-1.5">{action.icon}</span>}
              {action.label}
            </button>
          ))}
        </div>
        <button
          onClick={onClear}
          className="text-gray-400 hover:text-white text-sm whitespace-nowrap"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
